import { EU_COUNTRY_CODES } from './eu-country-codes';

/**
 * Determines if a user is based in the EU based on their country code.
 *
 * The country is provided by the backend, which derives it from the
 * user's IP address via MaxMind GeoIP2 (`geo_traits.country`).
 */
export const isEUUser = (country: string | null | undefined): boolean => {
  if (!country) {
    return false;
  }

  return EU_COUNTRY_CODES.has(country.toUpperCase());
};
